const getCellCareConfig = nodeEnv => {
    let baseURL;
    let proxyPrefix;
    switch (nodeEnv) {
        // dev
        case "dev":
        case "sit":
            baseURL = "https://smtalent-test.beautyfarm.com.cn";
            proxyPrefix = "";
            break;
        // 预发布
        case "pre":
            baseURL = "https://smtalent-pre.beautyfarm.com.c";
            proxyPrefix = "";
            break;
        // 正式
        case "prod":
            baseURL = "https://smtalent.beautyfarm.com.cn";
            proxyPrefix = "";
            break;
        // 默认
        default:
            baseURL = "http://localhost:8080";
            proxyPrefix = "/yapi";
            break;
    }
    return { baseURL, proxyPrefix };
};

export default getCellCareConfig;



// WEBPACK FOOTER //
// ./src/api/talent/config.js